<as-split class="hide-as-split-gutter" direction='vertical' gutterSize='1' useTransition (dragEnd)='onResize($event)'>
  <as-split-area [size]='splitPaneConfig[changesetSplitAreaKey].size' [minSize]='50'>
    <div class='full-height-flex'>
      <div class='changeset-header'>
        <adm4-validation-indicator [ngbTooltip]='popContentValidationErrors' placement='bottom-left' closeDelay="4000"
          [disableTooltip]="allProjectIssues.length < 1"

          [isDisplayed]='true'
          [isValid]='isValid'
          [isError]="isError"
          [isWarning]="isWarning">
        </adm4-validation-indicator>
        <div>Changed files</div>
        <ng-template #popContentValidationErrors>
          <adm4-project-issues-tooltip
            [generalIssues]="generalIssues$ | async"
            [patternIssueSeverityCount]="patternIssueNumberBySeverity$ | async"
            (navigateToIssues)="navigateToIssues()"
          ></adm4-project-issues-tooltip>
        </ng-template>
      </div>
      <div class='remaining-space-flex-content-wrapper'>
        <div class='remaining-space-flex-content publish-changeset-list-container'>
          <div class='changeset-list'>
            @for (changesetItem of changesetItems; track changesetItem) {
              <adm4-publish-changeset-item
                [changesetItem]='changesetItem'
                [isSelected]='isSelectedChangesetItem(changesetItem)'
                [projectKey]='projectKey'
                [currentUserName]='currentUserName'
                tabindex='0'
                (keydown.enter)='selectChangesetItem(changesetItem)'
                (keydown.space)='$event.preventDefault(); selectChangesetItem(changesetItem)'
                (click)='selectChangesetItem(changesetItem)'
                >
              </adm4-publish-changeset-item>
            }
          </div>
        </div>
      </div>
    </div>
  </as-split-area>
  <as-split-area [size]='splitPaneConfig[commitMessageSplitAreaKey].size' [minSize]='20'>
    <form class="d-contents" [formGroup]="form">
      <div class='h-100 d-flex flex-column commit-message-container'>
        <label for='comment'>Publish comment</label>
        <textarea id='comment' class="admn4-textarea-input" formControlName="commitMsg" placeholder='Publish message'></textarea>
        <div class="d-flex flex-column align-items-stretch mt-2">
          <label for='tag' class="me-2">Git Tag</label>
          <input id='tag' class="flex-grow-1 admn4-text-input mt-1" formControlName='tag' />
        </div>
      </div>
    </form>
  </as-split-area>
</as-split>
